import { useEffect, useState } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

function PropertyTypeDescriptionDropdown(propertyTypeId: string) {
  const [propertyDescriptions, setPropertyDescriptions] = useState<any>([]);
  const [loadingPropertyDescription, setLoadingPropertyDescription] = useState(false);
  const [isDropdownOpenPropertyDescription, setIsDropdownOpenPropertyDescription] = useState(false);

  const fetchPropertyTypes = async () => {
    if (loadingPropertyDescription) return;
    setLoadingPropertyDescription(true);

    try {
      const response = await axiosInstance.post(`${API_URLS.PropertyTypeWiseTypeDescription}`,
        {
          property_type_id: propertyTypeId,
        });

      if (response.data.data.rows) {
        setPropertyDescriptions(response.data.data.rows);
      }
    } catch (error) {
      console.error("Error fetching property type descriptions:", error);
    } finally {
      setLoadingPropertyDescription(false);
    }
  };

  useEffect(() => {
    if (propertyTypeId) {
      setPropertyDescriptions([]);
      fetchPropertyTypes();
    }
  }, [propertyTypeId]);

  return [
    setIsDropdownOpenPropertyDescription,
    isDropdownOpenPropertyDescription,
    fetchPropertyTypes,
    propertyDescriptions,
    loadingPropertyDescription,
    setIsDropdownOpenPropertyDescription,
  ];
}

export default PropertyTypeDescriptionDropdown;